import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Chart, Interval, Axis, Tooltip, Coordinate } from "bizcharts";
import DataSet from "@antv/data-set";
import { CircularProgress } from "@mui/material";

const getChunks = (array, chunk_size) =>
  Array(Math.ceil(array.length / chunk_size))
    .fill()
    .map((_, index) => index * chunk_size)
    .map((begin) => array.slice(begin, begin + chunk_size));

const Samples = (props) => {
  let data;
  let chunks;
  let scale;
  let sum;

  const height = props.chunkSize === 3 ? 160 : 170;

  if (props.data) {
    data = props.data.data;
    chunks = getChunks(data, props.chunkSize);
    scale = {
      Samples: {
        min: 0,
        max: Math.max(...props.data.data.map((d) => d["Samples"])),
      },
    };
    sum = data
      .map((c) => c["Samples"])
      .reduce((partialSum, a) => partialSum + a, 0);
  }

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 700);
  }, []);

  return (
    <Box padding={props.padding}>
      <Box
        sx={{
          display: { xs: "none", md: "contents" },
        }}
      >
        <p
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            marginBottom: "0.375rem",
          }}
        >
          <b>
            Number of samples taken per food group from{" "}
            {/* <u> */}
              {props.data !== undefined
                ? props.data.country === "All"
                  ? "all countries"
                  : props.data.country
                : ""}
            {/* </u> */}
          </b>
        </p>
      </Box>
      <Box
        sx={{
          display: { xs: "contents", md: "none" },
        }}
      >
        <p
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            marginBottom: "0.375rem",
          }}
        >
          <b>
            Number of samples taken per food group from{" "}
            {/* <u> */}
              {props.data !== undefined
                ? props.data.country === "All"
                  ? "all countries"
                  : props.data.country
                : ""}
            {/* </u> */}
          </b>
          <b> (Total : {props.data !== undefined ? sum : ""})</b>
        </p>
      </Box>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box display="flex">
          {props.data &&
            chunks.map((c, idx) => {
              const ds = new DataSet();
              const dv = ds.createView().source(c);
              return (
                <Box className={`test-${idx}`} key={idx} ml={"4px"}>
                  <Chart
                    scale={scale}
                    data={dv}
                    height={height}
                    width={135}
                    autoFit
                    padding={[10, 20, 0, 0]}
                  >
                    <Coordinate transpose />
                    <Axis name="Samples" visible={false} />
                    <Axis name="Food commodity" visible={false} />
                    <Tooltip visible={false} />
                    <Interval
                      color="#22294D"
                      label={{
                        fields: ["Samples", "Food commodity"],
                        cfg: {
                          position: "left",
                          offsetY: -10,
                          offsetX: -12,
                          style: {
                            fontFamily: "Roboto Condensed, sans-serif",
                          },
                        },

                        callback: (samples, commodity) => {
                          return {
                            content:
                              commodity +
                              ": " +
                              samples.toLocaleString() +
                              "  " +
                              "  " +
                              "  ",
                          };
                        },
                      }}
                      size={7}
                      style={{ height: 10 }}
                      position="Food commodity*Samples"
                    />
                  </Chart>
                </Box>
              );
            })}
        </Box>
      )}
    </Box>
  );
};

export default Samples;
